module.exports = __webpack_public_path__ + "static/media/rewards_circle.8341a212.png";